import React from 'react';
import { Section } from '@fiverr-private/layout_components';
import { JobHeroSection } from '../JobHeroSection';
import { JobDescriptionSection } from '../JobDescriptionSection';
import { ApplySection } from '../ApplySection';
import { UnusualWaySection } from '../UnusualWaySection';
import { Job, ComeetEmbedConfig } from '../../../lib/comeet';

export interface JobPageProps {
    job: Job;
    heroImage: string;
    isBlockedCountry?: boolean;
    comeetEmbedConfig?: ComeetEmbedConfig;
}

export const JobPage = ({ job, heroImage, isBlockedCountry, comeetEmbedConfig }: JobPageProps) => (
    <Section
        fullWidth
        backgroundColor="white"
        style={{
            maxWidth: '1440px',
        }}
    >
        <JobHeroSection job={job} heroImage={heroImage} />
        <JobDescriptionSection job={job} />
        {!isBlockedCountry && (
            <>
                <ApplySection positionUid={job.uid} comeetEmbedConfig={comeetEmbedConfig} />
                <UnusualWaySection />
            </>
        )}
    </Section>
);
